import { Action } from 'redux';

import { CreateRemoteExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IDataSourceDetailInfo } from '../../../datasource/models/IDataSourceInfo';

export interface CreateRemoteExtractRefreshAction extends Action {
  datasource: IDataSourceDetailInfo;
}

export function createRemoteExtractRefresh(datasource: IDataSourceDetailInfo): CreateRemoteExtractRefreshAction {
  return {
    type: CreateRemoteExtractRefresh,
    datasource,
  };
}
